import React, { useEffect, useState } from "react";
import {
  Button,
  makeStyles,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@material-ui/core";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";

import KPTable from "../../../components/KPTable";

import { getAllDepartments } from "../../../reducer/department/action";
import { getResearchHours } from "../../../reducer/timeResearchInformation/action";

const useStyles = makeStyles({
  button: {
    "&:disabled": {
      backgroundColor: "#fff",
      color: "#3c52b2",
    },
  },
});

const workTypeMap = {
  scientific_research: "Bài báo khoa học",
  scientificResearch: "Bài báo khoa học",
  solution: "Giải pháp hữu ích",
  patent: "Bằng sáng chế",
  research_project: "Đề tài nghiên cứu",
  researchProject: "Đề tài nghiên cứu",
  monograph: "Sách chuyên khảo",
  achievement: "Giải thưởng",
  exhibition: "Triển lãm",
  student_guidance: "Hướng dẫn sinh viên",
  studentGuidance: "Hướng dẫn sinh viên",
  scientific_council: "Hội đồng khoa học",
  scientificCouncil: "Hội đồng khoa học",
};

function TimeResearchTable(props) {
  const classes = useStyles();
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    props.getAllDepartments();
  }, [props.getAllDepartments]);

  useEffect(() => {
    loadResearchHours();
  }, [props.department, props.startDate, props.endDate, props.calAgain]);

  const loadResearchHours = () => {
    const payload = {
      departmentId: props.department === 0 ? undefined : props.department,
      startDate: props.startDate,
      endDate: props.endDate,
    };
    props.getResearchHours(payload);
  };

  const columns = [
    {
      title: <b>Tên thành viên</b>,
      key: "profileName",
      width: "20%",
      searchable: true,
      sorter: (a, b) => a.profileName.localeCompare(b.profileName),
      render: (value, row) => {
        return (
          // <a href={`${ROUTER.WORK}/profile-id=${row.profileId}`} style={{ color: "black", textDecoration: "none" }}>
          <b>{value}</b>
          // </a>
        );
      },
    },
    {
      title: <b>Khoa</b>,
      key: "departmentName",
      width: "20%",
      searchable: true,
      sorter: (a, b) => (a.departmentName || "").localeCompare(b.departmentName || ""),
      render: (value, row) => {
        return <b>{value || "N/A"}</b>;
      },
    },
    {
      key: "totalHours",
      width: "15%",
      sorter: (a, b) => a.totalHours - b.totalHours,
      title: <b>Tổng giờ</b>,
      render: (value) => <b>{value?.toFixed(2) || 0}</b>,
    },
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "10%",
      render: (value, row) => (
        <>
          <Typography className="table-action-buton" variant="caption" color="primary" onClick={() => setDetail(row)}>
            Chi tiết
          </Typography>
        </>
      ),
    },
  ];

  let data = [];
  let totalHours = 0;

  if (props.researchHours && Array.isArray(props.researchHours)) {
    data = props.researchHours.map((item) => {
      totalHours += item.totalHours || 0;

      // Find department name
      const department = props.departments?.find((d) => d.id === item.departmentId);

      return {
        profileId: item.profileId,
        profileName: item.profileName,
        departmentId: item.departmentId,
        departmentName: department?.name || "Không xác định",
        totalHours: item.totalHours,
        works: item.works || [],
      };
    });
  }

  const renderDetailTimeResearch = (detail) => {
    if (!detail || !detail.works || detail.works.length === 0) {
      return <Typography style={{ padding: 10 }}>Chưa có dữ liệu giờ nghiên cứu</Typography>;
    }

    // Group works by workType
    const groupedWorks = detail.works.reduce((acc, work) => {
      const type = work.workType;
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(work);
      return acc;
    }, {});

    // Sort groups alphabetically by Vietnamese name
    const sortedGroups = Object.keys(groupedWorks).sort((a, b) => {
      const nameA = workTypeMap[a] || a;
      const nameB = workTypeMap[b] || b;
      return nameA.localeCompare(nameB, "vi");
    });

    return (
      <div style={{ padding: 10 }}>
        <Typography variant="h6" style={{ marginBottom: 15 }}>
          <b>{detail.profileName}</b> - Tổng: <b>{detail.totalHours?.toFixed(2)}</b> giờ
        </Typography>
        {sortedGroups.map((type, groupIndex) => {
          const works = groupedWorks[type];
          const subtotal = works.reduce((sum, work) => sum + parseFloat(work.hours || 0), 0);
          const typeName = workTypeMap[type] || type;

          return (
            <div
              key={groupIndex}
              style={{
                marginBottom: 20,
              }}
            >
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: "bold",
                  marginBottom: 8,
                  color: "#1976d2",
                }}
              >
                {typeName} ({works.length} công trình - {subtotal.toFixed(2)} giờ)
              </Typography>
              <div
                style={{
                  paddingLeft: 16,
                  backgroundColor: "#f9f9f9",
                  borderRadius: 4,
                  padding: 12,
                }}
              >
                {works.map((work, workIndex) => (
                  <Typography
                    key={workIndex}
                    variant="body2"
                    style={{
                      marginBottom: 6,
                      paddingLeft: 8,
                    }}
                  >
                    • {work.title} (<b>{parseFloat(work.hours || 0).toFixed(2)}</b> giờ)
                  </Typography>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 228px)"
        columns={columns}
        rows={data}
        loading={props.isFetching}
      />

      <Button className={classes.button} color="primary" disabled style={{ left: 16, bottom: 44 }}>
        {`${props.departments.filter((item) => item.id === props.department)[0]?.name || "Tất cả đơn vị"}: ${totalHours.toFixed(
          2,
        )} giờ`}
      </Button>

      {detail && (
        <Dialog open={detail !== null} onClose={() => setDetail(null)} maxWidth="md" fullWidth>
          <DialogTitle>{"Chi tiết giờ nghiên cứu"}</DialogTitle>
          <DialogContent>{renderDetailTimeResearch(detail)}</DialogContent>
          <DialogActions>
            <Button onClick={() => setDetail(null)} color="primary" autoFocus>
              Đóng
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  departments: select(state, "departmentReducer", "departments"),
  researchHours: select(state, "timeResearchInformationReducer", "researchHours"),
  isFetching: select(state, "timeResearchInformationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllDepartments: () => dispatch(getAllDepartments()),
  getResearchHours: (payload) => dispatch(getResearchHours(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(TimeResearchTable));

